import { Button, ButtonProps } from "@chakra-ui/react";
import { useConnect } from "@particle-network/auth-core-modal";
import { useState } from "react";
import { LogoutIcon } from "../../icons";
import { logOut, useUserStore } from "../../providers/auth";
import Dialog from "../Dialog/Dialog";

interface Props extends ButtonProps {
  showtext?: string;
}

const Logout = (props?: Props) => {
  const user = useUserStore((state) => state.user);
  const showtext = props?.showtext === "true";
  const [showConfirmLogout, setShowConfirmLogout] = useState(false);
  const [loading, setLoading] = useState(false);
  const { disconnect } = useConnect();

  const confirmLogout = () => setShowConfirmLogout(true);
  const cancelLogout = () => setShowConfirmLogout(false);
  const handleLogout = () => {
    setLoading(true);
    logOut(disconnect);
  };

  const icon = <LogoutIcon width={6} height={6} />;
  if (!user) return <></>;
  return (
    <>
      <Button
        size="md"
        variant="outline"
        leftIcon={showtext ? icon : undefined}
        onClick={confirmLogout}
        {...props}
      >
        {showtext ? "Logout" : icon}
      </Button>
      <Dialog
        isOpen={showConfirmLogout}
        onClose={cancelLogout}
        title="Confirm Logout"
        loading={loading}
        actions={[
          {
            text: "Cancel",
            onClick: cancelLogout,
          },
          {
            text: "Confirm",
            primary: true,
            onClick: handleLogout,
          },
        ]}
      >
        <p className="text-center">Are you sure you want to logout?</p>
      </Dialog>
    </>
  );
};

export default Logout;
